// extracted by mini-css-extract-plugin
module.exports = {"banner":"WidgetBanner_banner__LxTJH","bannerText":"WidgetBanner_bannerText__1u_M7"};